/**
 * @file ShopErrorScreen.tsx
 *
 * Terminal screen shown when the shop bootstrap fails (the project/shop fetch or
 * the create errored). Offers a retry that re-runs the whole bootstrap.
 */

import { useIntl } from 'react-intl';
import { messages } from '../i18n/messages';
import { NoticeScreen } from './NoticeScreen';

export function ShopErrorScreen({ onRetry }: { onRetry: () => void }) {
  const intl = useIntl();
  return (
    <NoticeScreen
      role="alert"
      title={intl.formatMessage(messages.shopErrorTitle)}
      body={intl.formatMessage(messages.shopErrorBody)}
      action={{ label: intl.formatMessage(messages.retry), onClick: onRetry }}
    />
  );
}
